import type { PostEnriched } from '@/lib/db/types';

export interface MemberRoundStats {
  rounds_count: number;
  avg_gross: number | null;
  low_gross: number | null;
}

/** Derive leaderboard round stats from visible feed posts (full-18 for avg/low). */
export function statsFromPosts(posts: PostEnriched[]): Record<string, MemberRoundStats> {
  const map: Record<string, { all: number[]; full: number[] }> = {};

  for (const p of posts) {
    if (p.type !== 'round' || p.round?.gross_total == null) continue;
    const id = p.author_id;
    if (!map[id]) map[id] = { all: [], full: [] };
    map[id].all.push(p.round.gross_total);
    if (p.round.holes === 'full') map[id].full.push(p.round.gross_total);
  }

  const out: Record<string, MemberRoundStats> = {};
  for (const [id, { all, full }] of Object.entries(map)) {
    out[id] = {
      rounds_count: all.length,
      avg_gross: full.length
        ? Math.round((full.reduce((a, b) => a + b, 0) / full.length) * 10) / 10
        : null,
      low_gross: full.length ? Math.min(...full) : null,
    };
  }
  return out;
}

export function mergeMemberStats(
  member: { id: string; rounds_count: number; avg_gross: number | null; low_gross: number | null },
  fromPosts?: MemberRoundStats,
): { rounds_count: number; avg_gross: number | null; low_gross: number | null } {
  if (!fromPosts) return member;
  return {
    rounds_count: Math.max(member.rounds_count, fromPosts.rounds_count),
    avg_gross: member.avg_gross ?? fromPosts.avg_gross,
    low_gross: member.low_gross ?? fromPosts.low_gross,
  };
}
